import { moveToFulfilled, moveToPending, moveToRejected, remove, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  ClientSharePointWebLinkAttachmentDestroyAction,
  ClientSharePointWebLinkAttachmentDetailsLoadFulfilledAction,
  ClientSharePointWebLinkAttachmentDetailsLoadPendingAction,
  ClientSharePointWebLinkAttachmentDetailsLoadRejectedAction,
  ClientSharePointWebLinkAttachmentPreviewLoadFulfilledAction,
  ClientSharePointWebLinkAttachmentPreviewLoadPendingAction,
  ClientSharePointWebLinkAttachmentPreviewLoadRejectedAction,
} from '../../domains/resolveClientSharePointWebLink/actions.types';

import { ClientSharePointWebLink, ClientSharePointWebLinks } from './types';

export type ClientSharePointWebLinkAction =
  | ClientSharePointWebLinkAttachmentPreviewLoadFulfilledAction
  | ClientSharePointWebLinkAttachmentDetailsLoadFulfilledAction
  | ClientSharePointWebLinkAttachmentDetailsLoadPendingAction
  | ClientSharePointWebLinkAttachmentDetailsLoadRejectedAction
  | ClientSharePointWebLinkAttachmentPreviewLoadPendingAction
  | ClientSharePointWebLinkAttachmentPreviewLoadRejectedAction
  | ClientSharePointWebLinkAttachmentDestroyAction;

const initialState: ClientSharePointWebLinks = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const destroyClientSharePointWebLink = (state: ClientSharePointWebLinks, webLinkId: string) =>
  remove(state, [webLinkId]);

const updateClientSharePointWebLinkPreview = (
  state: ClientSharePointWebLinks,
  clientSharePointWebLink: ClientSharePointWebLink
) => {
  const fulfilledClientSharePointWebLink = state.fulfilled.byId[clientSharePointWebLink.id];

  // If only loading image, don't override description and title
  if (fulfilledClientSharePointWebLink) {
    const updatedLink = {
      previewImage: clientSharePointWebLink.previewImage,
    };

    return update(state, clientSharePointWebLink.id, updatedLink);
  }

  const record = { [clientSharePointWebLink.id]: clientSharePointWebLink };

  return moveToFulfilled(state, record);
};

const updateClientSharePointWebLinkDetails = (
  state: ClientSharePointWebLinks,
  clientSharePointWebLink: ClientSharePointWebLink
) => {
  const fulfilledClientSharePointWebLink = state.fulfilled.byId[clientSharePointWebLink.id];

  // If only loading details, don't override image
  if (fulfilledClientSharePointWebLink) {
    const updatedLink = {
      title: clientSharePointWebLink.title,
      description: clientSharePointWebLink.description,
    };

    return update(state, clientSharePointWebLink.id, updatedLink);
  }

  const record = { [clientSharePointWebLink.id]: clientSharePointWebLink };

  return moveToFulfilled(state, record);
};

const reducer: Reducer<ClientSharePointWebLinks, ClientSharePointWebLinkAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SHAREPOINT_WEBLINK_PREVIEW.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.clientSharePointWebLink.id], action.payload.error);
    case 'SHAREPOINT_WEBLINK_PREVIEW.LOAD_PENDING':
      return moveToPending(state, [action.payload.clientSharePointWebLink.id]);
    case 'SHAREPOINT_WEBLINK_PREVIEW.LOAD_FULFILLED':
      return updateClientSharePointWebLinkPreview(state, action.payload.clientSharePointWebLink);
    case 'SHAREPOINT_WEBLINK_DETAILS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.clientSharePointWebLink.id], action.payload.error);
    case 'SHAREPOINT_WEBLINK_DETAILS.LOAD_PENDING':
      return moveToPending(state, [action.payload.clientSharePointWebLink.id]);
    case 'SHAREPOINT_WEBLINK_DETAILS.LOAD_FULFILLED':
      return updateClientSharePointWebLinkDetails(state, action.payload.clientSharePointWebLink);
    case 'SHAREPOINT_WEBLINK.DESTROY':
      return destroyClientSharePointWebLink(state, action.payload.clientSharePointWebLinkId);
    default:
      return state;
  }
};

export default reducer;
